<section class="dashboard-management">
  <div class="dashboard-management__header">
    <app-breadcrumb
      [home]="home"
      [items]="breadcrumbs"
      [menuItems]="breadcrumbMenuItems"></app-breadcrumb>
    <div class="dashboard-management__header__actions">
      <!-- `*appHasPermission` além do `[hidden]`: são coisas diferentes. O `[hidden]`
           esconde mas MONTA o componente, e ele busca a lista de empresas no `ngOnInit` —
           quem não pode listar empresas (o parceiro, card 2901: "o seletor de escopo de
           empresa não aparece nesta fase") levava 403 e o toast de sem permissão só por
           abrir a Dashboard. Não montar é o que resolve. -->
      <app-select-company
        *appHasPermission="companyListPermission"
        [hidden]="isCompanyIdUser"
        [allowEmptyPlaceholderSelect]="true"
        [multiple]="true"
        [showLabel]="false"
        [selectionScope]="'page-filter'"
        [persistLocalSelectionToUrl]="true"
        [selectedCompanyValues]="selectedCompanyIds"
        [showCompanyIcon]="true"
        (sendSelectedOptionMultiple)="onDashboardManagementCompanySelectedMultiple($event)"
        [placeholder]="tk.General.AllCompanies | t"
        class="company-select company-select--header">
      </app-select-company>
      <app-button
        icon="sync"
        theme="white"
        size="small"
        class="dashboard-header-refresh"
        title="Atualizar a Home"
        [noMargin]="true"
        (sendClick)="refreshDashboardData()">
      </app-button>
    </div>
  </div>

  <!-- 1. Barra do Cog (card 3786): a pergunta abre o chat do botão flutuante abaixo. -->
  <app-home-cog-search (ask)="onAskCog($event)"></app-home-cog-search>

  <!-- 2. Blocos da Home na arrumação da pessoa (card 3788, gaveta Personalizar): ordem e quais aparecem vêm do
       HomeLayoutService; as linhas saem de groupHomeRows (dois blocos "metade" seguidos dividem a linha). Cada bloco
       mantém a condição de antes: cenário de economia e performance só com empresa escolhida e a flag
       (shouldShowDashboardEconomyScenario), Score com UMA empresa e CREDITSCORE_VIEW_COMPANY, Limites e Reuniões com a
       permissão de cada um (renderableHomeBlocks). -->
  @if (homeEmptyState; as emptyState) {
    <div class="dashboard-management__all-hidden" role="status">
      <i
        class="pi dashboard-management__all-hidden-icon"
        [class.pi-eye-slash]="emptyState === 'all-off'"
        [class.pi-building]="emptyState === 'needs-company'"
        aria-hidden="true"></i>
      @if (emptyState === 'all-off') {
        <p class="dashboard-management__all-hidden-title">Todos os blocos estão desligados.</p>
        <p class="dashboard-management__all-hidden-text">Use Personalizar para ligar de novo.</p>
      } @else {
        <p class="dashboard-management__all-hidden-title">Nenhum bloco ligado aparece agora.</p>
        <p class="dashboard-management__all-hidden-text">
          Os blocos ligados aparecem quando você escolhe uma empresa no seletor acima, ou use
          Personalizar para ligar outros.
        </p>
      }
      <app-button
        icon="sliders-h"
        theme="darkblue"
        size="small"
        label="Personalizar"
        [fitContent]="true"
        [noMargin]="true"
        (sendClick)="openCustomize()"></app-button>
    </div>
  }

  @for (row of homeRows; track row.join('|')) {
    <div [class]="homeRowClass(row)">
      @for (blockId of row; track blockId) {
        @switch (blockId) {
          @case ('economy') {
            <app-economy-scenario-cards
              [selectedCompanyIds]="selectedCompanyIds"
              [fillHeight]="economyFillsRow(row)"></app-economy-scenario-cards>
          }
          @case ('calendar') {
            <ng-container *ngTemplateOutlet="calendarBlock"></ng-container>
          }
          @case ('performance') {
            <app-debt-performance-chart
              [selectedCompanyIds]="selectedCompanyIds"></app-debt-performance-chart>
          }
          @case ('credit-score') {
            @if (selectedCompanyId) {
              <app-credit-score-strip [companyId]="selectedCompanyId" />
            }
          }
          @case ('bank-limits') {
            <app-home-bank-limits-card
              [companyId]="selectedCompanyId"
              [refreshKey]="refreshKey"></app-home-bank-limits-card>
          }
          @case ('meetings') {
            <app-home-meetings-card
              [companyId]="selectedCompanyId"
              [refreshKey]="refreshKey"
              [canOpenMeetings]="canListMeetings"></app-home-meetings-card>
          }
        }
      }
    </div>
  }

  <!-- Calendário de Vencimentos: o estado e a modal do dia continuam na página; aqui só o card. -->
  <ng-template #calendarBlock>
    <section class="dashboard-management__dashboard calendar-panel">
      <div class="calendar-panel__header">
        <h2 class="calendar-panel__title">Calendário de Vencimentos</h2>
      </div>
      <div class="calendar-panel__meta">
        <span class="calendar-panel__count">
          <i class="pi pi-calendar"></i>
          {{ calendarEventsCount }} vencimentos
        </span>
        <span class="calendar-panel__hint">
          <i class="pi pi-info-circle"></i>
          Clique numa data destacada para ver os eventos
        </span>
      </div>
      <div class="calendar-wrapper">
        <p-datePicker
          class="responsive-calendar"
          [(ngModel)]="currentDate"
          [inline]="true"
          [showOtherMonths]="false"
          [selectOtherMonths]="false"
          [numberOfMonths]="2"
          [view]="'date'"
          (onSelect)="onSelectDate($event)"
          (onMonthChange)="onMonthChange($event)">
          <ng-template pTemplate="date" let-date>
            <span
              [ngClass]="{
                'event-day': isHighlighted(date),
                'selected-day': isSelected(date),
              }">
              {{ date.day }}
            </span>
          </ng-template>
        </p-datePicker>
      </div>
      <div class="calendar-panel__upcoming">
        <div class="calendar-panel__upcoming-title">Próximos Vencimentos</div>
        @for (item of upcomingCalendarEvents; track item.date + '-' + item.index) {
          <button
            type="button"
            class="calendar-panel__event"
            [attr.aria-describedby]="'calendar-event-detail-' + item.date + '-' + item.index"
            (click)="onSelectDate(item.dateObject)">
            <span class="calendar-panel__event-date">
              {{ item.dateObject | date: 'dd/MM' }}
            </span>
            <span class="calendar-panel__event-name">
              {{ item.title }}
            </span>
            <span class="calendar-panel__event-value">
              {{ item.currencyCode }}
              {{ item.value | vaultFormatCurrency: 2 }}
            </span>
            <span
              class="calendar-panel__event-detail"
              [id]="'calendar-event-detail-' + item.date + '-' + item.index"
              role="tooltip">
              <span class="calendar-panel__event-detail-header">
                <span class="calendar-panel__event-detail-icon">
                  <i class="pi pi-calendar-clock"></i>
                </span>
                <span class="calendar-panel__event-detail-heading">
                  <span class="calendar-panel__event-detail-title">Detalhes do vencimento</span>
                  <span class="calendar-panel__event-detail-subtitle">
                    {{ item.title }}
                  </span>
                </span>
              </span>
              <span class="calendar-panel__event-detail-body">
                @for (row of item.detailRows; track row.label) {
                  <span class="calendar-panel__event-detail-row">
                    <span class="calendar-panel__event-detail-label">
                      {{ row.label }}
                    </span>
                    <span class="calendar-panel__event-detail-value">
                      {{ row.value }}
                    </span>
                  </span>
                }
              </span>
            </span>
          </button>
        } @empty {
          <div class="calendar-panel__empty">Sem vencimentos nos próximos meses</div>
        }
      </div>
      <a [routerLink]="['/dashboard/consolidated-due-date']" class="view-all-link">
        <span>Ver Tabela Completa</span>
        <span class="pi pi-arrow-right"></span>
      </a>
    </section>
  </ng-template>

  <app-dialog
    #calendarEventsDialog
    [key]="'date-events'"
    [action]="'date-events'"
    [headerTheme]="'simple'"
    [favorite]="calendarFavorite"
    [breakpoints]="{
      '960px': '400px',
      '768px': '95vw',
      '640px': '100vw',
      '480px': '100vw',
    }"
    [title]="(tk.General.EventsIn | t) + ' ' + dateFormatter.formatDateInstant(this.selectedDate)">
    <p-table
      [value]="selectedDateEvents"
      [paginator]="true"
      [rows]="15"
      [showCurrentPageReport]="true"
      [paginatorDropdownAppendTo]="'body'"
      styleClass="p-datatable-sm"
      currentPageReportTemplate="Exibindo 1 a {last} de {totalRecords}"
      [rowsPerPageOptions]="[5, 10, 15, 20, 30]"
      [(first)]="tablePage">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ tk.General.Reference | t }}</th>
          <th>{{ tk.General.Company | t }}</th>
          <th>{{ tk.General.Value | t }}</th>
          <th>{{ tk.Management.NdfDueDate | t }}</th>
          <th>{{ tk.User.Type | t }}</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-event>
        <tr>
          <!-- Se for loanOperation -->
          <ng-container *ngIf="event.loanOperation; else checkComexOperation">
            <td>{{ translateReference(event.loanOperation.reference) }}</td>
            <td>{{ event.loanOperation.companyName }}</td>
            <td>
              {{ event.loanOperation.currencyCode }}
              {{ event.loanOperation.value | vaultFormatCurrency: 2 }}
            </td>
            <td>{{ dateFormatter.formatDateInstant(selectedDate) }}</td>
            <td class="calendar-type-cell">
              Empréstimo
              <!-- Card 3201: o evento está na data em que a parcela foi paga, antes do vencimento -->
              @if (event.loanOperation.isEarlySettlement) {
                <span
                  class="calendar-early-settlement-badge"
                  [title]="
                    'Vencimento original: ' +
                    dateFormatter.formatDateInstant(event.loanOperation.dueAt, true)
                  ">
                  {{ earlySettlementBadge }}
                </span>
              }
            </td>
            <td>
              <a
                title="Ver operação"
                target="_blank"
                queryParamsHandling="merge"
                [routerLink]="[
                  '/dashboard/costs/debt/management/launch-installments',
                  event.loanOperation.id,
                ]">
                <span class="pi pi-eye color-text-brand-primary"></span>
              </a>
            </td>
          </ng-container>

          <!-- Se for comexOperation -->
          <ng-template #checkComexOperation>
            <ng-container *ngIf="event.comexOperation; else derivativeBlock">
              <td>{{ translateReference(event.comexOperation.reference) }}</td>
              <td>{{ event.comexOperation.companyName }}</td>
              <td>
                {{ event.comexOperation.currencyCode }}
                {{ event.comexOperation.lcValue | vaultFormatCurrency: 2 }}
              </td>
              <td>{{ dateFormatter.formatDateInstant(selectedDate) }}</td>
              <td>Comex</td>
              <td>
                <a
                  target="_blank"
                  [title]="tk.General.ViewOperation | t"
                  [routerLink]="['/dashboard/comex-operation/v1/edit', event.comexOperation.id]">
                  <span class="pi pi-eye color-text-brand-primary"></span>
                </a>
              </td>
            </ng-container>
          </ng-template>

          <!-- Se for derivativeOperation -->
          <ng-template #derivativeBlock>
            <td>{{ translateReference(event.derivativeOperation.demandReference) }}</td>
            <td>{{ event.derivativeOperation.companyName }}</td>
            <td>
              {{ event.derivativeOperation.currencyCode }}
              {{ event.derivativeOperation.notionalAmount | vaultFormatCurrency: 2 }}
            </td>
            <td>{{ dateFormatter.formatDateInstant(selectedDate) }}</td>
            <td>{{ event.type }}</td>
            <td>
              <a
                target="_blank"
                [title]="tk.General.ViewOperation | t"
                [routerLink]="['/dashboard/ndf-operation/list']"
                [queryParams]="{ filter: event.derivativeOperation.sequentialId }">
                <span class="pi pi-eye color-text-brand-primary"></span>
              </a>
            </td>
          </ng-template>
        </tr>
      </ng-template>
    </p-table>

    <ng-template #footer>
      <div class="dialog__footer">
        <app-button
          size="small"
          target="_blank"
          [label]="tk.General.ViewAll | t"
          [routerLink]="['/dashboard/ndf-operation/list']"
          [queryParams]="{ dueAt: dateFormatter.formatDateToYYYYMMDD(selectedDate) }">
        </app-button>
      </div>
    </ng-template>
  </app-dialog>

  <!-- Botão flutuante do Cog: também recebe as perguntas da barra do Cog. Sem empresa única, o chat
       segue no escopo do usuário (o agente resolve a empresa pelo nome), como na tela Cog IA. -->
  <!-- Gaveta Personalizar Dashboard (card 3788). -->
  <app-home-customize-drawer [(visible)]="customizeOpen"></app-home-customize-drawer>

  <app-floating-ai-button
    [companyId]="selectedCompanyId"
    [requireCompanySelection]="false"
    [autoInstruction]="cogInstruction"></app-floating-ai-button>
</section>
